/* eslint-disable react/display-name */
import { Button, Space, Table, TableProps, Tag, Typography } from 'antd';
import React, { useMemo } from 'react';
import ConfirmButton from 'src/components/atoms/ConfirmButton';
import { RoleEnum } from 'src/features/users/users.types';
import ComponentRoleProtected from 'src/components/blocks/ComponentRoleProtected';
import { Firmware } from 'src/features/firmwares/firmwares.types';

export interface DevicesTableProps {
  firmwares: Firmware[];
  className?: string;
  loading?: boolean;
  style?: React.CSSProperties;
  addMode: boolean;
  onRemove: (firmware: Firmware) => void;
  onAdd: (firmware: Firmware) => void;
}

const FirmwaresTable: React.FC<DevicesTableProps> = props => {
  const { firmwares, loading, onRemove, addMode, onAdd } = props;

  const tableConfig = useMemo<TableProps<Firmware>>(() => {
    const result: TableProps<Firmware> = {
      dataSource: firmwares,
      rowKey: values => values.id,
      columns: [
        {
          title: 'Название',
          dataIndex: 'name',
          key: 'name',
          render: (name: string, firmware) => (
            <Space direction={'horizontal'} style={{ justifyContent: 'space-between', width: '100%' }}>
              <Space direction={'vertical'} size={2}>
                <Space direction={'horizontal'} size={5}>
                  <span style={{ textTransform: 'uppercase' }}>{name || '-'}</span>{' '}
                </Space>
                <Typography.Text type={'secondary'}>{firmware.md5}</Typography.Text>
              </Space>
              <Space direction={'horizontal'}>
                {firmware.isTest && <Tag color='blue'>Тестовый</Tag>}
                {firmware.isActive && <Tag color='green'>Активная</Tag>}
              </Space>
            </Space>
          ),
        },
        {
          title: 'Версия',
          dataIndex: 'version',
          key: 'version',
          align: 'right',
          width: 100,
          sorter: (a, b) => a.version.localeCompare(b.version),
          render: version => <Typography.Text style={{ textTransform: 'uppercase' }}>{version || '-'}</Typography.Text>,
        },
        {
          title: 'Тип устройства',
          dataIndex: 'deviceType',
          key: 'deviceType',
          align: 'right',
          width: 100,
          sorter: (a, b) => a.deviceType.name.localeCompare(b.deviceType.name),
          render: value => (
            <Typography.Text style={{ textTransform: 'uppercase' }}>{value.name || '-'}</Typography.Text>
          ),
        },

        {
          title: 'Действия',
          dataIndex: 'actions',
          key: 'actions',
          align: 'right',
          render: (value, firmware) => (
            <ComponentRoleProtected roles={[RoleEnum.admin]}>
              {addMode ? (
                <Button type={'primary'} onClick={() => onAdd(firmware)}>
                  Добавить
                </Button>
              ) : (
                <ConfirmButton danger onClick={() => onRemove(firmware)}>
                  Удалить
                </ConfirmButton>
              )}
            </ComponentRoleProtected>
          ),
        },
      ],
    };
    return result;
  }, [addMode, firmwares, onAdd, onRemove]);

  return <Table {...tableConfig} size='middle' pagination={{ pageSize: 50 }} loading={loading} />;
};

export default FirmwaresTable;
